import React from 'react';
import { Link } from 'react-router-dom';

const features = [
  {
    icon: '⚡',
    title: 'Instant approval',
    desc: 'Instant decisions . No lengthy wait times.',
  },
  {
    icon: '📅',
    title: 'Flexible repayment',
    desc: 'Choose from minimum period of repayment : 1 year and maximum period of repayment : 3 years. Repay early with zero penalty.',
  },
  {
    icon: '🔒',
    title: '100% secure & RBI compliant',
    desc: 'Bank-grade encryption. Your data stays private, always.',
  },
];

const stats = [
  { num: '12L+', label: 'Happy borrowers' },
  { num: '4.8★', label: 'Avg. rating' },
  { num: 'fast', label: 'approval' },
];

export default function PayDayPanel() {
  return (
    <>
      <style>{`
        .pdp-panel {
          flex: 1 1 50%;
          background: #1e3a5f;
          padding: 3rem 2.5rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-width: 0;
          overflow: hidden;
        }
        .pdp-hero-amount {
          font-size: clamp(32px, 4vw, 52px);
          font-weight: 700;
          color: #ffffff;
          line-height: 1.1;
          margin-bottom: 10px;
        }
        @media (max-width: 768px) {
          .pdp-panel {
            flex: none;
            width: 100%;
            padding: 2rem 1.25rem;
          }
          .pdp-stats-row {
            gap: 8px !important;
          }
        }
      `}</style>

      <div className="pdp-panel">
        <div>
          {/* Logo */}
          

          {/* Hero */}
          <h1 className="pdp-hero-amount">Up to ₹1,00,000</h1>
          <p style={s.heroSub}>
            Get instant personal loans with minimal paperwork.
            <br />
            Approved in minutes, disbursed in hours.
          </p>

          {/* Features */}
          <div style={s.featureList}>
            {features.map((f, i) => (
              <div key={i} style={s.featItem}>
                <div style={s.featIcon}>{f.icon}</div>
                <div>
                  <p style={s.featTitle}>{f.title}</p>
                  <p style={s.featDesc}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Stats */}
          <div className="pdp-stats-row" style={s.statsRow}>
            {stats.map((st, i) => (
              <div key={i} style={s.statBox}>
                <p style={s.statNum}>{st.num}</p>
                <p style={s.statLabel}>{st.label}</p>
              </div>
            ))}
          </div>
          <Link to="https://kisgaleasing.com" target='_blank'>
          <p style={s.trustBar}>
             B4SALARY is owned by Kisga Leasing and Finance Pvt Ltd., a RBI-registered Non-Banking Financial Company (NBFC).
          </p>
          </Link>
          <a href='https://b4salary.com/RBI.jpeg' style={{color:"white"}}>VIEW RBI CERTIFICATE</a>
        </div>

        
      </div>
    </>
  );
}

const s = {
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '2rem',
  },
  logoIcon: {
    width: '36px',
    height: '36px',
    background: '#F97316',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: '700',
    flexShrink: 0,
  },
  logoName: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#F97316',
  },
  heroSub: {
    fontSize: '15px',
    color: '#93c5fd',
    marginBottom: '2rem',
    lineHeight: 1.6,
  },
  featureList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '2rem',
  },
  featItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '14px',
  },
  featIcon: {
    width: '38px',
    height: '38px',
    borderRadius: '10px',
    background: 'rgba(249,115,22,0.18)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    flexShrink: 0,
  },
  featTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#e2e8f0',
    marginBottom: '3px',
  },
  featDesc: {
    fontSize: '13px',
    color: '#94a3b8',
    lineHeight: 1.5,
  },
  statsRow: {
    display: 'flex',
    gap: '14px',
    marginBottom: '2rem',
  },
  statBox: {
    flex: 1,
    background: 'rgba(255,255,255,0.07)',
    borderRadius: '10px',
    padding: '12px 14px',
    border: '0.5px solid rgba(255,255,255,0.1)',
    minWidth: 0,
  },
  statNum: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#F97316',
    marginBottom: '3px',
    whiteSpace: 'nowrap',
  },
  statLabel: {
    fontSize: '11px',
    color: '#94a3b8',
  },
  trustBar: {
    fontSize: '12px',
    color: '#eeeff1',
    paddingTop: '1.5rem',
    borderTop: '0.5px solid rgba(255,255,255,0.1)',
  },
};
